import React from "react";
import { SuccessPageButton } from "./SuccessPage.styled";
import { useNavigate } from "react-router-dom";

const SuccessPage = (props) => {
  const { message, links } = props;
  const navigate = useNavigate();
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        height: "calc(100vh - 300px)",
      }}
    >
      <svg
        width="100"
        height="100"
        viewBox="0 0 100 100"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect width="100" height="100" fill="#7B36EE" />
        <g filter="url(#filter0_d_725_1840)">
          <path
            d="M67.0855 40.0517L44.9589 62.1783L32.9166 50.136L35.1558 47.8967L44.6054 57.3465L44.9589 57.7L45.3125 57.3465L64.8463 37.8125L67.0855 40.0517Z"
            fill="white"
            stroke="white"
          />
        </g>
        <defs>
          <filter
            id="filter0_d_725_1840"
            x="21"
            y="25"
            width="58"
            height="58"
            filterUnits="userSpaceOnUse"
            colorInterpolationFilters="sRGB"
          >
            <feFlood floodOpacity="0" result="BackgroundImageFix" />
            <feColorMatrix
              in="SourceAlpha"
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
              result="hardAlpha"
            />
            <feOffset dy="4" />
            <feGaussianBlur stdDeviation="2" />
            <feComposite in2="hardAlpha" operator="out" />
            <feColorMatrix
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
            />
            <feBlend
              mode="normal"
              in2="BackgroundImageFix"
              result="effect1_dropShadow_725_1840"
            />
            <feBlend
              mode="normal"
              in="SourceGraphic"
              in2="effect1_dropShadow_725_1840"
              result="shape"
            />
          </filter>
        </defs>
      </svg>

      <h4>{message}</h4>
      {links.map((link, index, row) => (
        <SuccessPageButton
          key={index}
          style={{ marginBlockStart: `${row === 1 ? "auto" : "10px"}` }}
          onClick={() => navigate(`${link.link}`)}
        >
          {link.name}
        </SuccessPageButton>
      ))}
    </div>
  );
};

export default SuccessPage;
